/**
 * 환율 표시 3상태 — 순수 함수(TRAD-3567). iOS TRAD-3557 `displayState` · android TRAD-3566 `exchangeDisplayState` 와 같은 규칙:
 *   - 값이 있으면 `list`(조회가 실패했어도 이미 가진 값은 그대로 보인다)
 *   - 값이 없고 실패면 `failed`(«환율 데이터를 불러오지 못했습니다» + 다시 시도)
 *   - 그 밖(로딩·아직 없음)은 `placeholder`(종전처럼 자리를 비운다)
 * 🔴 실패를 «값 없음» 과 같은 빈자리로 두면 사용자는 꺼 둔 것인지 고장인지 알 수 없다.
 */
export type ExchangeDisplayState = 'list' | 'failed' | 'placeholder';

export const exchangeDisplayState = (hasItems: boolean, isError: boolean): ExchangeDisplayState =>
  hasItems ? 'list' : isError ? 'failed' : 'placeholder';
